import { palette } from '$tablet-app/src/app/theme';
import { spacing } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { useEffect, useState } from 'react';
import { FlatList, Pressable, View } from 'react-native';
import { RobotDevice } from '../../types';
import { NearbyRobotItem } from './NearbyRobotItem';

type NearbyRobotDisplayProps = {
  robotDevices: RobotDevice[];
  onSelectRobot?: (robotDevice: RobotDevice | undefined) => void;
};

const itemDiameter = 190;

export const NearbyRobotDisplay = ({
  robotDevices,
  onSelectRobot,
}: NearbyRobotDisplayProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>();

  const onRobotPress = (index: number) => {
    setSelectedIndex(index);
  };

  useEffect(() => {
    if (selectedIndex !== undefined) {
      onSelectRobot?.(robotDevices[selectedIndex]);
    } else {
      onSelectRobot?.(undefined);
    }
  }, [onSelectRobot, robotDevices, selectedIndex]);

  return (
    <Pressable
      style={{
        marginBottom: spacing[3],
        flex: 1,
      }}
      onPress={() => setSelectedIndex(undefined)}
    >
      <FlatList
        keyExtractor={(device) => `nearby_robot_${device.id}`}
        style={{
          backgroundColor: palette.lightGrey1,
          borderRadius: 10,
          minWidth: (itemDiameter + spacing[4]) * 3.2,
        }}
        contentContainerStyle={{
          paddingVertical: spacing[3],
          paddingHorizontal: spacing[3] / 2,
          flexGrow: 1,
        }}
        numColumns={3}
        columnWrapperStyle={{
          justifyContent: 'space-evenly',
        }}
        data={robotDevices}
        renderItem={({ item, index, separators }) => (
          <NearbyRobotItem
            key={`nearby_robot_${index}`}
            robotDevice={item}
            onSelect={() => {
              onRobotPress(index);
              separators.unhighlight();
            }}
            isSelected={index === selectedIndex}
            itemDiameter={itemDiameter}
          />
        )}
        ListEmptyComponent={() => (
          <View
            style={{
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <FontAwesomeIcon icon="robot" color="#01010120" size={60} />
          </View>
        )}
      />
    </Pressable>
  );
};
